
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from '../../Pages/Home/Home';
import RoutesMaster from '../RoutesMaster/RoutesMaster';
import RoutesPlayer from '../RoutesPlayer/RoutesPlayer';
import { INDEX_MASTER_PATH, INDEX_PLAYER_PATH } from "../../Services/routeNames";
import './globalStyle.scss';

export default function RoutesIndex() {

    return (
        <div>
            <BrowserRouter>
                <Routes>
                    <Route index element={<Home />} />
                    <Route path={INDEX_MASTER_PATH + "/*"} element={<RoutesMaster />} />
                    <Route path={INDEX_PLAYER_PATH + "/*"} element={<RoutesPlayer />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}